import URL from '../url'
import Request from '../request'
import { get as getCookie } from 'es-cookie'

/**
 *
 * @param {*} query
 */
export const mediaVideoGetByFilterService = query =>
  new Request(URL.API, URL.MEDIA_VIDEO_GET_BY_FILTER).post(query)

/**
 *
 * @param {*} id
 */
export const mediaVideoGetByIdService = id =>
  new Request(URL.API, URL.MEDIA_VIDEO_GET_BY_ID).get({ id })

/**
 *
 * @param {*} formData
 */
export const mediaVideoUploadManyService = formData =>
  new Request(URL.API, URL.MEDIA_VIDEO_UPLOAD_MANY).post(formData)

/**
 *
 * @param {*} formData
 */
export const mediaVideoUploadService = formData =>
  new Request(URL.API, URL.MEDIA_VIDEO_UPLOAD).post(formData)

/**
 *
 * @param {*} content
 */
export const mediaVideoPatchService = content =>
  new Request(URL.API, URL.MEDIA_VIDEO_PATCH).patch(content)

/**
 *
 * @param {*} id
 */
export const mediaVideoDeleteService = id =>
  new Request(URL.API, URL.MEDIA_VIDEO_DELETE).delete(id)

/**
 *
 * @param {*} ids
 */
export const mediaVideoDeleteListService = ids =>
  new Request(URL.API, URL.MEDIA_VIDEO_DELETE_LIST).post(ids)

export const videoSubtitleUploadService = async (shopClipId, videoUrl, subtitleFile, language, label, isDefault) => {
  const token = getCookie('token')
  const formData = new FormData()
  if (shopClipId) {
    formData.append('shopClipId', shopClipId)
  } else if (videoUrl) {
    formData.append('videoUrl', videoUrl)
  }
  formData.append('subtitleFile', subtitleFile)
  formData.append('language', language)
  if (label) formData.append('label', label)
  if (isDefault !== undefined) formData.append('default', String(isDefault))

  const response = await fetch(`${URL.API}video/subtitles`, {
    method: 'PUT',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: formData,
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(errorText || `Subtitle upload failed: ${response.status}`)
  }

  return { data: await response.json() }
}

export const videoSubtitleDeleteService = async (shopClipId, videoUrl, language) => {
  const token = getCookie('token')
  const params = new URLSearchParams()
  if (shopClipId) {
    params.append('shopClipId', shopClipId)
  } else if (videoUrl) {
    params.append('videoUrl', videoUrl)
  }
  params.append('language', language)

  const response = await fetch(`${URL.API}video/subtitles?${params.toString()}`, {
    method: 'DELETE',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(errorText || `Subtitle delete failed: ${response.status}`)
  }

  return { data: null }
}

export const videoSubtitlePatchService = async (shopClipId, videoUrl, language, patchBody) => {
  const token = getCookie('token')
  const params = new URLSearchParams()
  if (shopClipId) {
    params.append('shopClipId', shopClipId)
  } else if (videoUrl) {
    params.append('videoUrl', videoUrl)
  }
  params.append('language', language)

  const response = await fetch(`${URL.API}video/subtitles?${params.toString()}`, {
    method: 'PATCH',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json-patch+json',
    },
    body: JSON.stringify(patchBody),
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(errorText || `Subtitle patch failed: ${response.status}`)
  }

  return { data: null }
}

export const videoSubtitleGetService = async (shopClipId, videoUrl) => {
  const token = getCookie('token')
  const params = new URLSearchParams()
  if (shopClipId) {
    params.append('shopClipId', shopClipId)
  } else if (videoUrl) {
    params.append('videoUrl', videoUrl)
  }

  const response = await fetch(`${URL.API}video/subtitles?${params.toString()}`, {
    method: 'GET',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(errorText || `Subtitle list failed: ${response.status}`)
  }

  return { data: await response.json() }
}
